/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-closing-tag-location */
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import { GET_PROJECT_AND_RECON_CONFIG_DETAILS } from 'Apollo/Queries/DataRecon';
import { RUN_RECONCILIATION_STATUS } from 'Apollo/Queries/DataRecon/DataConfiguration';
import Loader from 'views/Shared/components/Loader';
import { GET_USERS } from 'Apollo/Queries';
import {
    activeDataReconMenuVar, showDataReconMenusVar, leftNavigationItemsVar,
    currentLeftMenuVar,
} from 'Apollo/config';
import { ModuleEnum } from 'constants';
import crossReportImg from 'assets/images/cross-report-black.svg';
import ReconStatus from '../components/ReconStatus';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const getUpdatedIndicators = (prevData, updatedData) => {
    let updateState = [...prevData];
    if (!updateState.includes(`${updatedData}%`)) {
        updateState = updateState.concat(`${updatedData}%`);
    }
    return updateState;
};

const ReconciliationStatus = () => {
    const history = useHistory();
    const location = useLocation();
    const [progress, setProgress] = useState(0);
    const [indicators, setIndicators] = useState(['0%']);
    const [status, setStatus] = useState('NOT STARTED');
    const [userNames, setUserNames] = useState('');
    const [errorReason, setErrorReason] = useState('N/A');

    const maxProgressPercent = 100;

    const {
        projectId, project, tenantId, reconStartTime,
    } = location.state;

    /* apollo query to fetch project users */
    const users = useQuery(GET_USERS, {
        variables: {
            input: {
                tenantId: parseInt(tenantId, 10),
                getAll: true,
            },
        },
    });

    /* apollo query to fetch reconciliation configuration details */
    const {
        data,
    } = useQuery(GET_PROJECT_AND_RECON_CONFIG_DETAILS, {
        variables: {
            input: {
                projectId: parseInt(project.projectId, 10),
                parentProjectId: parseInt(project.parentProjectId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
    });

    /* apollo query to fetch reconciliation status */
    const {
        loading: reconStatLoading, error: reconStatError, data: reconStatData,
        startPolling, stopPolling,
    } = useQuery(RUN_RECONCILIATION_STATUS, {
        variables: {
            input: {
                projectId: parseInt(projectId, 10),
                reconStartTime,
            },
        },
        pollInterval: 10000,
        fetchPolicy: 'no-cache',
    });
    let projectDetails;
    if (data && data.getProjectAndReconConfigDetails) {
        projectDetails = data.getProjectAndReconConfigDetails.projectDetails;
    }

    /* function to get users' names from list of user ids */
    const getUserName = userIds => {
        let names = '';
        if (userIds && userIds.length > 0) {
            userIds.forEach(id => {
                if (users.data) {
                    const result = users.data.getUsers.find(user => user.userId === id);
                    const name = result ? result.fullName : '';
                    names += `${name},`;
                }
            });
        }
        return names;
    };

    /* callback function called when View Result button is clicked */
    const onViewResult = () => {
        history.push({
            pathname: '/datareconresult',
            state: {
                tenantId, project,
            },
        });
    };

    /* function to navigate to projects page */
    const navigateToProjects = () => history.push(
        {
            pathname: '/projects',
            state: {
                tenantId,
            },
        },
    );

    /* function to navigate to configuration page */
    const navigateToConfigPage = () => history.push(
        {
            pathname: '/dataconfiguration',
            state: {
                projectId: projectDetails.projectId,
                tenantId,
                project,
            },
        },
    );

    /* Breadcrumb Items */
    const breadCrumbItems = [
        {
            link: '',
            value: <span className="appkiticon icon-home-fill font-16" onClick={navigateToProjects} role="presentation" />,
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text" onClick={navigateToProjects} role="presentation"> Projects </span>,
        },
        {
            link: '',
            value: <span
                className="a-breadcrumb-item-text"
                onClick={() => {
                    history.push({
                        pathname: '/data-lineage-upload',
                        state: {
                            tenantId, project,
                        },
                    });
                }}
                role="presentation"
            >
                {project && project.projectName}
            </span>,
        },
        {
            link: '',
            value: <span
                className="a-breadcrumb-item-text"
                onClick={() => {
                    history.push({
                        pathname: '/dataconfiguration',
                        state: {
                            projectId: project && project.projectId,
                            tenantId,
                            project,
                        },
                    });
                }}
                role="presentation"
            >
                Data Configuration
            </span>,
        },
    ];

    /* side effect called when component loads */
    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
    }, []);

    /* side effect when reconStatsData, reconStatError is changed */
    useEffect(() => {
        if (reconStatData?.getCurrentReconStatus) {
            setProgress(reconStatData.getCurrentReconStatus.reconStatusInPercent);
            setIndicators(prevState => getUpdatedIndicators(prevState, reconStatData.getCurrentReconStatus.reconStatusInPercent));
            setStatus(prevState => {
                if (reconStatData.getCurrentReconStatus.reconRunStatus) {
                    return reconStatData.getCurrentReconStatus.reconRunStatus;
                }
                return prevState;
            });
            setErrorReason(prevState => {
                if (reconStatData.getCurrentReconStatus.failureReason) {
                    return reconStatData.getCurrentReconStatus.failureReason;
                }
                return prevState;
            });
        }
        if (reconStatError || (
            reconStatData?.getCurrentReconStatus?.reconStatusInPercent !== maxProgressPercent && reconStatData?.getCurrentReconStatus?.reconRunStatus === 'FAILURE'
        )
        ) {
            setErrorReason(reconStatError || reconStatData?.getCurrentReconStatus.failureReason);
            stopPolling();
        } else if (reconStatData?.getCurrentReconStatus?.reconStatusInPercent === maxProgressPercent && reconStatData?.getCurrentReconStatus?.reconRunStatus === 'SUCCESS'
        ) {
            stopPolling();
        } else {
            setErrorReason('N/A');
        }
    }, [startPolling, stopPolling, reconStatError, reconStatData]);

    /* side effect when projectDetails and users are changed */
    useEffect(() => {
        setUserNames(getUserName(projectDetails && projectDetails.userIdArr));
        showDataReconMenusVar(true);
        activeDataReconMenuVar('projects');
    }, [projectDetails, users]);

    if (reconStatLoading) {
        return <Loader />;
    }
    return (
        <div>
            <ReconStatus
                projectDetails={projectDetails}
                progress={progress}
                indicators={indicators}
                status={status}
                userNames={userNames}
                breadCrumbItems={breadCrumbItems}
                onViewResult={onViewResult}
                navigateToConfigPage={navigateToConfigPage}
                errorReason={errorReason}
                maxProgressPercent={maxProgressPercent}
            />
        </div>
    );
};

export default ReconciliationStatus;
